import React, {
  forwardRef,
  ReactNode,
  useEffect,
  useImperativeHandle,
} from 'react';
import classNames from 'classnames';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import { Button, Dropdown } from 'ncoded-component-library';
import { useLocation } from 'react-router-dom';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';

import './OverflowMenu.styles.scss';

type OverflowMenuProps = {
  className?: string;
  title?: string;
  children?: ReactNode;
};

const OverflowMenu: React.ForwardRefRenderFunction<
  DropdownRef,
  OverflowMenuProps
> = ({ className, title, children }, ref) => {
  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>(null);

  const classes = classNames('overflow-menu', className);

  const { pathname, search } = useLocation();

  useImperativeHandle(ref, () => dropdown, [dropdown]);

  useEffect(() => {
    dropdown?.setIsOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);

  return (
    <Dropdown
      ref={dropdownRef}
      className={classes}
      portalClassName="overflow-menu__portal"
      renderAsPortal
      trigger={
        <Button>
          {title}
          <ChevrondownIcon />
        </Button>
      }
    >
      {children}
    </Dropdown>
  );
};

export default forwardRef(OverflowMenu);
